import React, { useState } from 'react';
import { colors } from '@omilia/theme';
import { useTranslation } from '@omilia/providers';
import { MessageStatus } from 'types';
import { maskSensitiveText } from 'utils/maskSensitiveText';
import {
  SEyeIcon,
  SEyeSlashIcon,
  SRevealButton,
  SSensitiveBubble,
  SSensitiveText,
} from './sensitiveUserMessage.styled';

interface SensitiveUserMessageProps {
  message: string;
  status?: MessageStatus;
}

const SensitiveUserMessage: React.FC<SensitiveUserMessageProps> = ({
  message,
  status,
}) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const { t } = useTranslation();

  const displayText = isRevealed ? message : maskSensitiveText(message);
  const iconColor =
    status === MessageStatus.PENDING || status === MessageStatus.ERROR
      ? status === MessageStatus.ERROR
        ? colors.COLOR_RED_700
        : colors.COLOR_GREY_900
      : colors.COLOR_WHITE;

  return (
    <SSensitiveBubble status={status} role="user">
      <SSensitiveText>{displayText}</SSensitiveText>
      <SRevealButton
        data-test="reveal-button-dialog"
        type="button"
        onClick={() => setIsRevealed(prev => !prev)}
        aria-label={t(isRevealed ? 'footer.hideInput' : 'footer.revealInput')}
        aria-pressed={isRevealed}
      >
        {isRevealed ? (
          <SEyeSlashIcon primaryColor={iconColor} size="20" />
        ) : (
          <SEyeIcon primaryColor={iconColor} size="20" />
        )}
      </SRevealButton>
    </SSensitiveBubble>
  );
};

export default SensitiveUserMessage;
